module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('x-header', [_vm._v("\n            地址列表 (" + _vm._s(this.addressList.length) + "/" + _vm._s(_vm.limitNumber) + ")\n        ")]), _vm._v(" "), _c('div', [(_vm.addressList.length) ? _c('group', {
    attrs: {
      "title": "向左滑动可编辑和删除地址"
    }
  }, [_c('swipeout', _vm._l((_vm.addressList), function(item, index) {
    return _c('swipeout-item', {
      key: item.id,
      ref: "s+{$item.id}",
      refInFor: true,
      attrs: {
        "transition-mode": "follow"
      }
    }, [_c('div', {
      attrs: {
        "slot": "right-menu"
      },
      slot: "right-menu"
    }, [_c('swipeout-button', {
      attrs: {
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.onButtonClick('edit', item, index)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('swipeout-button', {
      attrs: {
        "type": "warn"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.onButtonClick('delete', item, index)
        }
      }
    }, [_vm._v(" 删除 ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "address-item-box",
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('div', {
      staticClass: "address-l1"
    }, [_c('span', {
      staticStyle: {
        "color": "#d4880f",
        "padding-right": "10px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(_vm._s(item.tel) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "address-l2"
    }, [_c('span', {
      staticStyle: {
        "display": "block"
      }
    }, [_vm._v(" " + _vm._s(item.provence + ' ' + item.city + ' ' + item.region) + "\n                                ")]), _vm._v("\n                                " + _vm._s(item.street) + "\n                            ")])])])
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "15px 5px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addressList.length >= _vm.limitNumber
    },
    nativeOn: {
      "click": function($event) {
        _vm.addAddress()
      }
    }
  }, [_vm._v("增加地址\n            ")])], 1)], 1), _vm._v(" "), _c('div', [_c('popup', {
    attrs: {
      "position": "right",
      "width": "100%"
    },
    model: {
      value: (_vm.showEditAddress),
      callback: function($$v) {
        _vm.showEditAddress = $$v
      },
      expression: "showEditAddress"
    }
  }, [_c('x-header', {
    attrs: {
      "left-options": {
        preventGoBack: true
      }
    },
    on: {
      "on-click-back": function($event) {
        _vm.showEditAddress = false
      }
    }
  }, [_vm._v("地址编辑\n            ")]), _vm._v(" "), _c('group', [_c('x-input', {
    attrs: {
      "title": "收货人",
      "placeholder": "收货人（中文）",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formAddress['name']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'name', $$v)
      },
      expression: "formAddress['name']"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "收货电话",
      "max": 11,
      "is-type": "china-mobile",
      "placeholder": "11位手机号码",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formAddress['tel']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'tel', $$v)
      },
      expression: "formAddress['tel']"
    }
  }), _vm._v(" "), _c('x-address', {
    attrs: {
      "title": "收货地址",
      "list": _vm.addressData,
      "placeholder": "点击选择省市区",
      "popup-style": {
        zIndex: 502
      }
    },
    model: {
      value: (_vm.formAddress['pcr']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'pcr', $$v)
      },
      expression: "formAddress['pcr']"
    }
  }), _vm._v(" "), _c('x-textarea', {
    attrs: {
      "title": "详细地址",
      "placeholder": "",
      "placeholder-align": "right"
    },
    model: {
      value: (_vm.formAddress['street']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'street', $$v)
      },
      expression: "formAddress['street']"
    }
  }), _vm._v(" "), _c('x-switch', {
    attrs: {
      "title": "是否默认",
      "value-map": [0, 1]
    },
    model: {
      value: (_vm.formAddress['is_default']),
      callback: function($$v) {
        _vm.$set(_vm.formAddress, 'is_default', $$v)
      },
      expression: "formAddress['is_default']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "40px",
      "padding": "10px"
    }
  }, [_c('x-button', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.postAddress()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071b4b24"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uc/Address.vue
// module id = 642
// module chunks = 0